/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_Text_DescriptionInputs */

const en_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy dialogue from overlapping events in one group into another`)
};

const fr_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le dialogue des événements qui se chevauchent d'un groupe vers un autre`)
};

const de_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog aus überlappenden Ereignissen einer Gruppe in eine andere kopieren`)
};

const it_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia il dialogo dagli eventi sovrapposti di un gruppo in un altro`)
};

const ru_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать текст из перекрывающихся событий одной группы в другую`)
};

const es_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar diálogo de eventos superpuestos de un grupo a otro`)
};

const zh_cn2_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将一个组中重叠事件的文本复制到另一个组`)
};

const ja_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複するイベントのテキストを別のグループにコピーします`)
};

const hi_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक समूह में ओवरलैप होने वाले इवेंट्स से दूसरे समूह में संवाद कॉपी करें`)
};

const pt_pt2_copy_event_text_description = /** @type {(inputs: Copy_Event_Text_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar diálogo de eventos sobrepostos de um grupo para outro`)
};

/**
* | output |
* | --- |
* | "Copy dialogue from overlapping events in one group into another" |
*
* @param {Copy_Event_Text_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text_description = /** @type {((inputs?: Copy_Event_Text_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_Text_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_event_text_description(inputs)
	if (locale === "de") return de_copy_event_text_description(inputs)
	if (locale === "it") return it_copy_event_text_description(inputs)
	if (locale === "ru") return ru_copy_event_text_description(inputs)
	if (locale === "es") return es_copy_event_text_description(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_event_text_description(inputs)
	if (locale === "ja") return ja_copy_event_text_description(inputs)
	if (locale === "hi") return hi_copy_event_text_description(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_event_text_description(inputs)
	return en_copy_event_text_description(inputs)
});